// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as OrderDashboardDataMachine from "./OrderDashboardDataMachine.bs.js";

function reducer(action, state) {
  switch (action.TAG | 0) {
    case /* SetBaseData */0 :
        return {
                TAG: /* Dashboard */0,
                user: action.user,
                order_details: action.order_details,
                order_fare: action.order_fare,
                tickets: {
                  TAG: /* Loading */0,
                  _0: undefined
                },
                scheduled_order_data: {
                  TAG: /* Loading */0,
                  _0: undefined
                },
                load_assist_info: undefined
              };
    case /* SetTickets */1 :
        if (typeof state === "number" || state.TAG !== /* Dashboard */0) {
          return state;
        } else {
          return {
                  TAG: /* Dashboard */0,
                  user: state.user,
                  order_details: state.order_details,
                  order_fare: state.order_fare,
                  tickets: action.tickets,
                  scheduled_order_data: {
                    TAG: /* Loading */0,
                    _0: undefined
                  },
                  load_assist_info: state.load_assist_info
                };
        }
    case /* SetScheduledOrderData */2 :
        if (typeof state === "number" || state.TAG !== /* Dashboard */0) {
          return state;
        } else {
          return {
                  TAG: /* Dashboard */0,
                  user: state.user,
                  order_details: state.order_details,
                  order_fare: state.order_fare,
                  tickets: state.tickets,
                  scheduled_order_data: action.scheduled_order_data,
                  load_assist_info: state.load_assist_info
                };
        }
    case /* SetLoadAssistInfo */3 :
        if (typeof state === "number" || state.TAG !== /* Dashboard */0) {
          return state;
        } else {
          return {
                  TAG: /* Dashboard */0,
                  user: state.user,
                  order_details: state.order_details,
                  order_fare: state.order_fare,
                  tickets: state.tickets,
                  scheduled_order_data: state.scheduled_order_data,
                  load_assist_info: action.load_assist_info
                };
        }
    case /* SetError */4 :
        return {
                TAG: /* Error */1,
                _0: action._0
              };
    
  }
}

function fetchTickets(order_id, dispatch) {
  return function (param) {
    return OrderDashboardDataMachine.fetchTicketsForOrder(order_id, (function (tickets) {
                  return Curry._1(dispatch, {
                              TAG: /* SetTickets */1,
                              tickets: {
                                TAG: /* Live */1,
                                _0: tickets
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetTickets */1,
                              tickets: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }), param);
  };
}

function fetchOrderSchedule(order_id, country, dispatch) {
  return OrderDashboardDataMachine.fetchOrderScheduleStatus(order_id, country, (function (scheduleOrderData) {
                return Curry._1(dispatch, {
                            TAG: /* SetScheduledOrderData */2,
                            scheduled_order_data: {
                              TAG: /* Live */1,
                              _0: scheduleOrderData
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetScheduledOrderData */2,
                            scheduled_order_data: {
                              TAG: /* Error */2,
                              _0: error
                            }
                          });
              }));
}

function fetchLoadAssistInfo(order_crn, country, dispatch) {
  return OrderDashboardDataMachine.fetchLoadAssistInfo(order_crn, (function (loadAssistInfo) {
                return Curry._1(dispatch, {
                            TAG: /* SetLoadAssistInfo */3,
                            load_assist_info: loadAssistInfo
                          });
              }), (function (_error) {
                return Curry._1(dispatch, {
                            TAG: /* SetLoadAssistInfo */3,
                            load_assist_info: undefined
                          });
              }), country);
}

function fetchBaseData(order_id, dispatch, country) {
  return Promise.all([
                  OrderDashboardDataMachine.fetchCurrentUserDetails(country),
                  OrderDashboardDataMachine.fetchOrder(order_id, country),
                  OrderDashboardDataMachine.fetchOrderFares(order_id, country)
                ]).then(function (param) {
                var order_fare = param[2];
                var order_details = param[1];
                var user = param[0];
                if (user.TAG === /* Ok */0) {
                  if (order_details.TAG === /* Ok */0) {
                    if (order_fare.TAG === /* Ok */0) {
                      return Promise.resolve(Curry._1(dispatch, {
                                      TAG: /* SetBaseData */0,
                                      user: user._0,
                                      order_details: order_details._0,
                                      order_fare: order_fare._0
                                    }));
                    } else {
                      return Promise.resolve(Curry._1(dispatch, {
                                      TAG: /* SetError */4,
                                      _0: order_fare._0
                                    }));
                    }
                  } else {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: /* SetError */4,
                                    _0: order_details._0
                                  }));
                  }
                } else {
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: /* SetError */4,
                                  _0: user._0
                                }));
                }
              }).catch(function (exp) {
              console.log(exp);
              return Promise.resolve(Curry._1(dispatch, {
                              TAG: /* SetError */4,
                              _0: /* DefaultError */{
                                _0: {
                                  title: {
                                    TAG: /* UnprocessedEntity */1,
                                    _0: undefined
                                  },
                                  message: "Unable to decode json object"
                                }
                              }
                            }));
            });
}

export {
  reducer ,
  fetchTickets ,
  fetchOrderSchedule ,
  fetchLoadAssistInfo ,
  fetchBaseData ,
  
}
/* OrderDashboardDataMachine Not a pure module */
